import { QuizResponse } from 'src/types'

export const upsertQuizResponse = (responses: QuizResponse[], key: string, values: string): QuizResponse[] => {
  const idx = responses.findIndex((e) => e.key === key)
  if (idx > -1) {
    return responses.map((e) => (e.key === key ? { ...e, values } : e))
  }
  return [...responses, { key, values }]
}
